import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Admin from '@/pages/Admin';
import HostConsole from '@/pages/HostConsole';
import ParticipantView from '@/pages/ParticipantView';
import Backoffice from '@/pages/Backoffice';
import SessionInfo from '@/pages/SessionInfo';
import SessionHistory from '@/pages/SessionHistory';
import EventMode from '@/pages/EventMode';
import DemoConsole from '@/pages/DemoConsole';
import GlossaryManager from '@/pages/GlossaryManager';
import ReportView from '@/pages/ReportView';
import ClientPortal from '@/pages/ClientPortal';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/host" element={<HostConsole />} />
          <Route path="/join/:code" element={<ParticipantView />} />
          <Route path="/session-info/:code" element={<SessionInfo />} />
          <Route path="/backoffice" element={<Backoffice />} />
          <Route path="/history" element={<SessionHistory />} />
          <Route path="/event/:sessionId" element={<EventMode />} />
          <Route path="/demo" element={<DemoConsole />} />
          <Route path="/demo/:sessionId" element={<DemoConsole />} />
          <Route path="/glossaries" element={<GlossaryManager />} />
          <Route path="/report/:sessionId" element={<ReportView />} />
          <Route path="/portal" element={<ClientPortal />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;